module.exports = __webpack_public_path__ + "static/media/Beetle.c6881e58.png";